module.exports = __webpack_public_path__ + "img/btn_order_all_open.e9bd7c2e.svg";